// extracted by mini-css-extract-plugin
module.exports = {"conseil":"conseil_conseil__2bv6B","primary":"conseil_primary__3HOr6"};